var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (sets, undefined) {
jade_mixins["featuredLinks"] = jade_interp = function(items){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<figure" + (jade.cls(["feature-set-item feature-set-item-" + (item.layoutStyle(items.length)) + ""], [true])) + ">");
if ( item.has('href') && item.hasImageForLayout(items.length))
{
buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"feature-set-item-image-link hoverable-image-link\"><img" + (jade.attr("src", item.imageUrlForLayout(items.length), true, true)) + " class=\"feature-set-item-image\"></a>");
}
else if ( item.hasImageForLayout(items.length))
{
buf.push("<img" + (jade.attr("src", item.imageUrlForLayout(items.length), true, true)) + " class=\"feature-set-item-image\">");
}
buf.push("<figcaption class=\"feature-set-item-caption\">");
if ( item.has('title'))
{
buf.push("<h3 class=\"feature-set-item-caption-heading\">");
if ( item.has('href'))
{
buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + ">" + (null == (jade_interp = item.mdToHtml('title')) ? "" : jade_interp) + "</a>");
}
else
{
buf.push(null == (jade_interp = item.mdToHtml('title')) ? "" : jade_interp);
}
buf.push("</h3>");
}
if ( item.get('subtitle'))
{
buf.push("<h4 class=\"feature-set-item-caption-subheading\">");
if ( item.get('href'))
{
buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + ">" + (null == (jade_interp = item.mdToHtml('subtitle')) ? "" : jade_interp) + "</a>");
}
else
{
buf.push(null == (jade_interp = item.mdToHtml('subtitle')) ? "" : jade_interp);
}
buf.push("</h4>");
}
buf.push("</figcaption></figure>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<figure" + (jade.cls(["feature-set-item feature-set-item-" + (item.layoutStyle(items.length)) + ""], [true])) + ">");
if ( item.has('href') && item.hasImageForLayout(items.length))
{
buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"feature-set-item-image-link hoverable-image-link\"><img" + (jade.attr("src", item.imageUrlForLayout(items.length), true, true)) + " class=\"feature-set-item-image\"></a>");
}
else if ( item.hasImageForLayout(items.length))
{
buf.push("<img" + (jade.attr("src", item.imageUrlForLayout(items.length), true, true)) + " class=\"feature-set-item-image\">");
}
buf.push("<figcaption class=\"feature-set-item-caption\">");
if ( item.has('title'))
{
buf.push("<h3 class=\"feature-set-item-caption-heading\">");
if ( item.has('href'))
{
buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + ">" + (null == (jade_interp = item.mdToHtml('title')) ? "" : jade_interp) + "</a>");
}
else
{
buf.push(null == (jade_interp = item.mdToHtml('title')) ? "" : jade_interp);
}
buf.push("</h3>");
}
if ( item.get('subtitle'))
{
buf.push("<h4 class=\"feature-set-item-caption-subheading\">");
if ( item.get('href'))
{
buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + ">" + (null == (jade_interp = item.mdToHtml('subtitle')) ? "" : jade_interp) + "</a>");
}
else
{
buf.push(null == (jade_interp = item.mdToHtml('subtitle')) ? "" : jade_interp);
}
buf.push("</h4>");
}
buf.push("</figcaption></figure>");
    }

  }
}).call(this);

};
jade_mixins["videoTemplate"] = jade_interp = function(video, posterSize){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ( video.has('subtitle'))
{
buf.push("<div class=\"feature-set-video-caption\">" + (null == (jade_interp = video.mdToHtml('subtitle')) ? "" : jade_interp) + "</div>");
}
else
{
buf.push("<video" + (jade.attr("data-id", video.get('id'), true, true)) + " preload=\"auto\"" + (jade.attr("poster", video.posterUrl(posterSize), true, true)) + " width=\"100%\" height=\"100%\">");
// iterate video.get('video_extensions')
;(function(){
  var $$obj = video.get('video_extensions');
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var ext = $$obj[$index];

buf.push("<source" + (jade.attr("src", video.srcUrl(ext), true, true)) + ">");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var ext = $$obj[$index];

buf.push("<source" + (jade.attr("src", video.srcUrl(ext), true, true)) + ">");
    }

  }
}).call(this);

buf.push("</video>");
}
};
jade_mixins["videosTemplate"] = jade_interp = function(videos){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate videos
;(function(){
  var $$obj = videos;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var video = $$obj[$index];

switch (video.layoutStyle(videos.length)){
case "full":
buf.push("<div" + (jade.attr("data-id", video.get('id'), true, true)) + " class=\"feature-set-video feature-set-video-full\"><div class=\"video-triggers\"><div class=\"video-play-trigger\"><div class=\"video-play-arrow\">&#9658;</div><div class=\"video-play-label\">Watch the video</div></div><div class=\"video-skip-trigger\"><div class=\"video-skip-arrow\">&#9660;</div><div class=\"video-skip-label\">See the works</div></div></div>");
jade_mixins["videoTemplate"](video, 'large_cinematic');
buf.push("</div>");
  break;
case "half":
buf.push("<div" + (jade.attr("data-id", video.get('id'), true, true)) + " class=\"feature-set-video feature-set-video-half\">");
jade_mixins["videoTemplate"](video, 'large_cinematic');
buf.push("</div>");
  break;
case "third":
buf.push("<div" + (jade.attr("data-id", video.get('id'), true, true)) + " class=\"feature-set-video feature-set-video-third\">");
jade_mixins["videoTemplate"](video, 'large_cinematic');
buf.push("</div>");
  break;
case "quarter":
buf.push("<div" + (jade.attr("data-id", video.get('id'), true, true)) + " class=\"feature-set-video feature-set-video-quarter\">");
jade_mixins["videoTemplate"](video, 'medium_rectangle');
buf.push("</div>");
  break;
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var video = $$obj[$index];

switch (video.layoutStyle(videos.length)){
case "full":
buf.push("<div" + (jade.attr("data-id", video.get('id'), true, true)) + " class=\"feature-set-video feature-set-video-full\"><div class=\"video-triggers\"><div class=\"video-play-trigger\"><div class=\"video-play-arrow\">&#9658;</div><div class=\"video-play-label\">Watch the video</div></div><div class=\"video-skip-trigger\"><div class=\"video-skip-arrow\">&#9660;</div><div class=\"video-skip-label\">See the works</div></div></div>");
jade_mixins["videoTemplate"](video, 'large_cinematic');
buf.push("</div>");
  break;
case "half":
buf.push("<div" + (jade.attr("data-id", video.get('id'), true, true)) + " class=\"feature-set-video feature-set-video-half\">");
jade_mixins["videoTemplate"](video, 'large_cinematic');
buf.push("</div>");
  break;
case "third":
buf.push("<div" + (jade.attr("data-id", video.get('id'), true, true)) + " class=\"feature-set-video feature-set-video-third\">");
jade_mixins["videoTemplate"](video, 'large_cinematic');
buf.push("</div>");
  break;
case "quarter":
buf.push("<div" + (jade.attr("data-id", video.get('id'), true, true)) + " class=\"feature-set-video feature-set-video-quarter\">");
jade_mixins["videoTemplate"](video, 'medium_rectangle');
buf.push("</div>");
  break;
}
    }

  }
}).call(this);

};
// iterate sets
;(function(){
  var $$obj = sets;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var set = $$obj[$index];

buf.push("<section class=\"feature-set\">");
if ( set.get('name'))
{
buf.push("<h2 class=\"feature-set-title\">" + (null == (jade_interp = set.mdToHtml('name')) ? "" : jade_interp) + "</h2>");
}
if ( set.get('description'))
{
buf.push("<h3 class=\"feature-set-description\">" + (null == (jade_interp = set.mdToHtml('description', { sanitize: false })) ? "" : jade_interp) + "</h3>");
}
switch (set.get('type')){
case 'artworks':
buf.push("<div id=\"feature-artworks\" class=\"artwork-columns-sale\"></div>");
  break;
case 'featured links':
jade_mixins["featuredLinks"](set.models());
  break;
case 'video':
jade_mixins["videosTemplate"](set.models());
  break;
}
buf.push("</section>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var set = $$obj[$index];

buf.push("<section class=\"feature-set\">");
if ( set.get('name'))
{
buf.push("<h2 class=\"feature-set-title\">" + (null == (jade_interp = set.mdToHtml('name')) ? "" : jade_interp) + "</h2>");
}
if ( set.get('description'))
{
buf.push("<h3 class=\"feature-set-description\">" + (null == (jade_interp = set.mdToHtml('description', { sanitize: false })) ? "" : jade_interp) + "</h3>");
}
switch (set.get('type')){
case 'artworks':
buf.push("<div id=\"feature-artworks\" class=\"artwork-columns-sale\"></div>");
  break;
case 'featured links':
jade_mixins["featuredLinks"](set.models());
  break;
case 'video':
jade_mixins["videosTemplate"](set.models());
  break;
}
buf.push("</section>");
    }

  }
}).call(this);
}.call(this,"sets" in locals_for_with?locals_for_with.sets:typeof sets!=="undefined"?sets:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;